import { useCallback, useContext, useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

export function useNavigatorConfirm(confirmCb: () => Promise<boolean>, needConfirm: boolean) {
    const { navigator } = useContext(NavigationContext);

    useEffect(() => {
        if (!needConfirm)
            return;

        const push = navigator.push;

        navigator.push = async (...args: Parameters<typeof push>) => {
            const result = await confirmCb();
            if (result !== false) {
                push(...args);
            }
        };

        return () => {
            navigator.push = push;
        };
    }, [navigator, confirmCb, needConfirm]);
}


export default function useNavigatorPrompt(promtCb: (cb: (resolve: boolean) => void) => void, needConfirm: boolean) {

    const confirmExit = useCallback(() => {
        return new Promise<boolean>((resolve) => {
            promtCb(resolve);
        });
    }, [promtCb]);

    useNavigatorConfirm(confirmExit, needConfirm);
}
